import BOM_DIAGNOSIS from './bom-diagnosis'
import FOOD_BUSINESS_ORDER from './food-business-order'
import BUSINESS_DATA_SEARCH from './business-data-search'
import THEORY_COST_ORDER from './theory-cost-order'
export default {
	'cost-manage': {
		id: 'cost-manage',
		label: '成本管理',
		code: '0006',
		child: {
			...BOM_DIAGNOSIS,
			...FOOD_BUSINESS_ORDER,
			...BUSINESS_DATA_SEARCH,
			...THEORY_COST_ORDER
		}
	}
}
